// extracted by mini-css-extract-plugin
export default {"wrapper":"FlatSidebar_wrapper__2XaNz","closeButton":"FlatSidebar_closeButton__5dhpw","hidden":"FlatSidebar_hidden__awjRB"};